import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

/**
 * Story 24.7b — `fullViewport` (`min-h-dvh`) is for the public catch-all
 * outside MainLayout. Inside MainLayout the page sits in the bounded
 * `<main>` and fills it (`min-h-full`).
 */
export default function NotFoundPage({ fullViewport = false }: { fullViewport?: boolean } = {}) {
  return (
    <div className={`${fullViewport ? 'min-h-dvh' : 'min-h-full'} flex items-center justify-center bg-canvas py-12 px-4 sm:px-6 lg:px-8`}>
      <div className="max-w-md w-full text-center">
        <h1 className="text-6xl font-bold text-ink mb-4">404</h1>
        <h2 className="text-3xl font-bold text-ink mb-4">Page Not Found</h2>
        <p className="text-ink-muted mb-8">
          The page you're looking for doesn't exist.
        </p>
        <Button asChild size="lg">
          <Link to="/">Go Back Home</Link>
        </Button>
      </div>
    </div>
  );
}
